import React, {useState, useEffect} from 'react';
import { Folha, LayoutBuscadorLateral, ItemBuscadorLateral, Dinheiro, Estoque} from '../../../componentes';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt,  faFileCode, faSackDollar , faHandPointer, faBoxUsd} from '@fortawesome/pro-duotone-svg-icons';

import { List, Row, Form, Input, Divider, Descriptions, Empty,Skeleton,Spin,Tag, Select, Button, Col, DatePicker, Drawer, Timeline, Modal} from 'antd';
import {useProdutos} from '../../../hooks/useProdutos';

import {useMovimentacoes} from '../../../hooks/useMovimentacoes';

import './ajustes.scss';

import { faSlidersVSquare } from '@fortawesome/pro-duotone-svg-icons';

import {  LoadingOutlined  } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/pt_BR';


const { Option } = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker

const EstoqueAjuste = ({onChange, onValueChange, suffix, customInput}) =>{


    const onChangeThis = (value) => {
        onValueChange && onValueChange(value);
        let v = value.floatValue || 0;
        v = parseFloat(v.toFixed(4));
        
        
        onChange && onChange(v);
    }

    return  <Estoque 
        onValueChange={onChangeThis}
        displayType="input" 
        customInput={customInput} 
        type="text" 
        
        suffix={suffix}
    />

}



const Ajustes = () => {

    const [buscando, setBuscando] = useState(false);
    const [buscandoLotes, setBuscandoLotes] = useState(false);
    const [buscandoHistorico, setBuscandoHistorico] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    

    
    const [itemSelecionado, setItemSelecionado] = useState({});
    const [listaProdutos, setListaProdutos] = useState([]);
    const [mostrarFormularioMovimentacao, setMostrarFormularioMovimentacao] = useState(false);
    
    const [termoBusca, setTermoBusca] = useState("");
    const [historicoMovimentacoes , setHistoricoMovimentacoes] = useState([]);
    const {listarProdutosEstoque, listarEstoqueProdutoPorLote, buscaHistoricoMovimentacoes, adicionarSaldo} = useProdutos();

    const [rangeDataHistorico, setRangeDataHistorico] = useState([
         moment().subtract(30, "days"),
         moment()
    ])
    
    const [form] = Form.useForm();

    

    useEffect(() => {
        lerProdutosEmEstoque();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const lerProdutosEmEstoque = async () => {
        setBuscando(true);
        const produtos = await listarProdutosEstoque();
        setListaProdutos(produtos);
        if(itemSelecionado && itemSelecionado.uuid){
            produtos.forEach(async produto => {
                if(produto.uuid === itemSelecionado.uuid){
                    await (selecionaProduto(produto))();
                    setBuscando(false);
                }
            });
        } else {
            setBuscando(false);

        }
    }

    


    const onChangeTermoBuscaHandler = (evt) => {
        setTermoBusca(evt.target.value);
    }

    
   

   

    const deveExibirProduto = (produto) =>{
        return (!termoBusca || termoBusca === "") 
                || (
                    (termoBusca)
                    && ((produto.codigo && produto.codigo.toUpperCase().indexOf(termoBusca.toUpperCase()) >=0)
                        || (produto.ncm && produto.ncm === termoBusca) 
                        || (produto.descricao && produto.descricao.toUpperCase().indexOf(termoBusca.toUpperCase()) >= 0)
                       )
                   );
    
    }

    const selecionaProduto = (produto) => async () => {
        setItemSelecionado(produto);
        setBuscandoLotes(true)
        

        const lotes = await listarEstoqueProdutoPorLote(produto.uuid);
        produto.lotes = lotes;
        
        setBuscandoLotes(false);
        buscaHistoricoMovimentacaoHandler(produto)

        
        
        
        

        
    }

    const buscaHistoricoMovimentacaoHandler = async(produto) => {
        setBuscandoHistorico(true);
        const historico =  await buscaHistoricoMovimentacoes(produto , rangeDataHistorico[0], rangeDataHistorico[1]);
        setHistoricoMovimentacoes(historico);
        setBuscandoHistorico(false);
    }

    

    const renderizaItens = () => {

        const renderizaTagPreco = (valor) =>{
                
                    return (<Tag color="green">
                        <Dinheiro value={valor} />
                        </Tag>);
                
        }
        const renderizaTagEstoque = (saldo, un) =>{
            
            return (<Tag color="blue">
                    <Estoque value={saldo} unMedida={un}></Estoque>
                </Tag>);
            
        }
        return listaProdutos.map(produto => {
            
                if( deveExibirProduto(produto) ){

                    return (
                    <ItemBuscadorLateral onClick={selecionaProduto(produto)} selecionado={itemSelecionado.uuid === produto.uuid} >
                        <span class="descricao">{produto.descricao}</span>
                        <span class='codigo'>#{produto.codigo}</span>  
                        <span class='ncm'>NCM: {produto.ncm}</span>  
                        <span class='tag-wrapper'>
                            <span class='tag'>
                                {renderizaTagPreco((produto.vUnCom) || 0)}
                            </span>  
                            <span class='tag'>
                                {renderizaTagEstoque(produto.saldoEstoque, produto.uCom)}
                            </span>  

                        </span>
                    </ItemBuscadorLateral>)

                } else {
                    return <></>;
                }
            
        
        }
        );
        

    }
    

    const renderizaFormularioMovimentacao = () => {
        const layout ={
            
            labelCol: {
                span: 24,
              },
              wrapperCol: {
                span: 24,
            }
        }

        
        let quantidadeDigitada = 0;

        const calculoQtdFutura = (value) => {
            if(value.floatValue !== undefined){
                
                quantidadeDigitada = value.floatValue;
            } 
            if(form.getFieldValue("fluxo") === "ENTRADA"){
                const qtdFutura = (parseFloat(itemSelecionado.saldoEstoque) + parseFloat(quantidadeDigitada || 0 ));
                return form.setFieldsValue({qtdFutura});
            } 
            const qtdFutura = (itemSelecionado.saldoEstoque - (quantidadeDigitada || 0 ));
            return form.setFieldsValue({qtdFutura});
            
        }

        const registraMovimentacao = () => async () => {
            setLoadingForm(true);
            let movimentacao = form.getFieldsValue();
            movimentacao.uuidProduto = itemSelecionado.uuid;
            movimentacao.origem = "MANUAL";
            movimentacao.status = "PUBLISHED";
            await adicionarSaldo(movimentacao)
            setLoadingForm(false);
            form.resetFields();
            closeForm();
        }

        const closeForm = () => {
            setMostrarFormularioMovimentacao(false);
            lerProdutosEmEstoque();
            //fechar
        }

        const numeroMaiorZero = async (formInstance, valor) => {
            
            if(!isNaN(valor) && valor > 0){
                return;
            }
            throw new Error("Quantidade deve ser maior que zero");
            
        }

       
        return (

            <Form form={form} layout="vertical" {...layout} loading={loadingForm} onFinish={registraMovimentacao()}>
                <Form.Item name="quantidade" rules={[{
                    required: true,
                    message: "Campo obrigatório"
                } ,{
                    validator: numeroMaiorZero,
                    message: "Valor deve ser maior que zero"
                }]} label="Quantidade" initialValue={1} >
                    <EstoqueAjuste
                        onValueChange={calculoQtdFutura}
                        customInput={Input} 
                        suffix={" " + (itemSelecionado.uCom || "")}
                    />
                    
                </Form.Item>
                <Form.Item rules={[{
                    required: true,
                    message: "Campo obrigatório"
                }]} name="fluxo" label="Tipo de Movimentacao" >
                    <Select  onChange={calculoQtdFutura}>
                        <Option value="ENTRADA">Entrada no Estoque</Option>
                        <Option value="SAIDA">Saida do Estoque</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="validade" label="Data de Validade" >
                    <DatePicker style={{width: "100%"}} format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item name="lote" label="Lote" >
                    <Input />
                </Form.Item>
                <Form.Item name="observacao" label="Observacao" >
                    <TextArea />
                </Form.Item>

             
                
                    
                <Row style={{
                    marginBottom: "10px",
                    background: "#EEE",
                    padding: "12px",
                }}>
                    <Col span={24}>
                        Quantidade Atual: {itemSelecionado.saldoEstoque} {itemSelecionado.uCom} &nbsp;
                        Quantidade Futura: &nbsp;
                        <Form.Item style={{
                            margin: "0",
                            padding: "0",
                            display: "inline"
                        }} noStyle={true} name="qtdFutura" initialValue={(itemSelecionado.saldoEstoque)}>
                            <Estoque unMedida={" " + (itemSelecionado.uCom || "")}></Estoque> 
                        </Form.Item>
                    </Col>
                </Row>    
                    
                    
                <Row>
                    <Col  style={{textAlign: "right"}} span={24}>
                        <Form.Item noStyle={true} style={{float:"right"}} >
                            <Button htmlType="subimit" type="primary" loading={loadingForm} >Registrar Movimentacao</Button>
                        </Form.Item>
                    </Col>

                </Row>
            </Form>
        )
    }

    

    const renderizaItemSelecionado = () => {

        const renderizaLotes = () => {

            
            return (<List
                dataSource={itemSelecionado.lotes}
                bordered={true}
                size="small"
                renderItem={item => (<List.Item>
                    <Skeleton loading={buscandoLotes}>
                        <List.Item.Meta
                        
                            title={(item.validade) ? "V: " + moment(item.validade, "YYYY-MM-DD").format("DD/MM/YYYY") : "Validade não informada" }
                            description={"[" + (item.lote || "Lote não informado") + "]"} 
                        ></List.Item.Meta>
                        <div>
                        <Tag><Estoque value={item.saldoEstoque} unMedida={(" " + (item.uCom || "")  )}></Estoque></Tag>
                        </div>

                    </Skeleton>
                </List.Item>)}
            />)
        }

        const renderizaHistorico = () => {
            const extrato = []
            const icones = {
                "NFe": faFileCode,
                "VENDA": faSackDollar,
                "MANUAL": faHandPointer,
                "DEFAULT": faBoxUsd
            }
            const cores = {
                "SAIDA": "red",
                "ENTRADA": "green"
            }
            historicoMovimentacoes.forEach(itemExtrato => {
                
                

                
                itemExtrato.movimentacoes.forEach(mov => {
                    let verVenda = <></>;
                    
                    
                  
                    if(mov.origem == "VENDAS"){
                        verVenda = <ButtonDetalhaVenda movimentacao={mov}></ButtonDetalhaVenda>
                    }
                    let lote = <></>;
                    let validade = <></>;
                    let observacao = <></>;
                    if(mov.validade){
                        validade = <Tag style={{display: "inline"}}>{moment(mov.validade).format("DD/MM/YYYY")}</Tag>
                    }

                    if(mov.lote){
                        lote = <Tag style={{display: "inline"}}>L: {mov.lote}</Tag>
                    }

                    if(mov.observacao){
                        observacao = <Tag style={{display: "inline"}}>{mov.observacao}</Tag>
                    }

                    extrato.push(
                        

                            <Timeline.Item 
                                color={cores[mov.fluxo]}
                                style={{wordBreak: "unset"}}
                                dot={
                                    <FontAwesomeIcon size="2x" icon={ (icones[mov.origem] || faBoxUsd) }></FontAwesomeIcon>
                                }
                            > <Tag style={{display: "inline"}}><Estoque value={mov.quantidade} unMedida={(itemSelecionado.uCom || "")}></Estoque> { (mov.origem || "N/D") }</Tag> 
                               {validade} 
                               {lote}
                               {observacao}
                               {verVenda}
                            </Timeline.Item>

                        
                    )
                });

                extrato.push(<Timeline.Item label={itemExtrato.data} color={(itemExtrato.saldoFinal > 0)? "blue": "red"}>
                        <Tag color={(itemExtrato.saldoFinal > 0)? "success": "red"}>Saldo em Estoque <Estoque value={itemExtrato.saldoFinal} unMedida={(itemSelecionado.uCom || "")}></Estoque></Tag> 
                    </Timeline.Item>);

            });

            return (<>
                <Row style={{marginBottom: '30px'}}>
                    <Col>
                        <Form layout="inline" size="small">
                            <Form.Item >
                                <RangePicker onChange={(newDates)=> setRangeDataHistorico(newDates)} defaultValue={rangeDataHistorico} format="DD-MM-YYYY" locale={locale}/>
                            </Form.Item>

                          
                            <Button loading={buscandoHistorico} onClick={()=> buscaHistoricoMovimentacaoHandler(itemSelecionado)}>Ok</Button>
                        </Form>
                    </Col>

                </Row>
                <Spin spinning={buscandoHistorico} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
                    <Timeline mode="left" reverse={true}>{extrato}</Timeline>
                </Spin>
            </>
            );
        }

        if(!itemSelecionado || !itemSelecionado.uuid){
            return (<Empty>Nenhum Produto Selecionado</Empty>)
        }

        
        const { descricao, codigo, vUnCom, saldoEstoque, uCom ,ncm, quantidadeEstoqueInicial, estoqueMinimo, dataEstoqueInicial}  = itemSelecionado;
        let classNamesSaldoEstoque = ["saldoEstoque"];

        if(saldoEstoque < 0){
            classNamesSaldoEstoque.push("negativo");
        } else if(saldoEstoque < estoqueMinimo){
            classNamesSaldoEstoque.push("alerta");
        }

        return(<>
            <Row style={{textAlign: "left"}}>
                <Col flex="auto">
                    <h2><span class='codigo'>{codigo}</span>{descricao} {estoqueMinimo}</h2>
                </Col>
                <Col flex="200px" className={classNamesSaldoEstoque}>
                    <span>{saldoEstoque} {uCom}</span>
                </Col>

                {/* <Descriptions column={3} title={descricao} layout="horizontal" size="small">
                    <Descriptions.Item label="Código">{codigo}</Descriptions.Item> */}
                    {/* <Descriptions.Item span={2} label="Descrição">{descricao}</Descriptions.Item> */}
                    {/* <Descriptions.Item label="Data Estoque Inicial">{moment(dataEstoqueInicial).format("DD/MM/YYYY")}</Descriptions.Item> */}
                    {/* <Descriptions.Item label="Estoque Inicial"  span={2}><Estoque value={quantidadeEstoqueInicial} unMedida={uCom}></Estoque></Descriptions.Item>
                    <Descriptions.Item label="Saldo em Estoque" className="saldoEstoque"><Estoque value={saldoEstoque} unMedida={uCom}></Estoque></Descriptions.Item> */}
                    {/* <Descriptions.Item label="Preço Venda"><Dinheiro value={(vUnCom || 0)}></Dinheiro></Descriptions.Item> */}
                {/* </Descriptions> */}
                
                
            </Row>
            <Row className="detalhesItem">
                <Col className="NCM">
                    <span>NCM {ncm}</span>
                </Col>
                <Col className="preco">
                    <span>Preço de venda: <Dinheiro value={vUnCom || 0}></Dinheiro></span>
                </Col>
                <Col className="estoqueInicial">
                    <span>Estoque Inicial: {quantidadeEstoqueInicial} {uCom} em {moment(dataEstoqueInicial).format("DD/MM/YYYY")}</span>
                </Col>
                
            </Row>
            <Divider>
                <small>Estoque por Lote e Data de Validade</small>
            </Divider>
            <Row>
                <Col span={24} style={{
                    textAlign: "left"
                }}>
                    {renderizaLotes()}
                </Col>
            </Row>
            <Divider>
                <small>Histórico de Movimentações</small> <Button size="small" type="primary" onClick={()=>{setMostrarFormularioMovimentacao(true)}}><FontAwesomeIcon icon={faSlidersVSquare}></FontAwesomeIcon>Ajustar</Button>
            </Divider>
            

                    <Row style={{marginTop: "23px", textAlign: "left"}}>
                        <Col colspan={24} style={{textAlign: "left"}}>
                        
                            {renderizaHistorico()}
                        </Col>
                        
                        
                        
                    </Row>
                
            <Drawer width={400} visible={mostrarFormularioMovimentacao}  onClose={()=> { setMostrarFormularioMovimentacao(false); }}>

                {renderizaFormularioMovimentacao()}
            </Drawer>
        </>
        );
        

        
    }

    return (
    <LayoutBuscadorLateral
        search={{
            onSearch: lerProdutosEmEstoque, 
            placeholder: "Busque um produto",
            loading: buscando,
            enterButton: (<FontAwesomeIcon icon={faRedoAlt}></FontAwesomeIcon>),
            onChange: onChangeTermoBuscaHandler,
            items: renderizaItens()
        }}

    >
    <Folha>
        {renderizaItemSelecionado()}
    </Folha>
    </LayoutBuscadorLateral>
       
    );
}


const ButtonDetalhaVenda = ({movimentacao}) => {

    const [loadingVendas, setLoadingVendas] = useState(false);
    const {getOrigemMovimentacao} = useMovimentacoes();

    const abrirVendaMov = async ()=>{
        setLoadingVendas(true);
        const origem = await getOrigemMovimentacao(movimentacao);
        if(origem){
            setLoadingVendas(false);
            Modal.info({
                title: "Detalhes da Venda",
               
                content: (<>
                    <Row>
                        {origem.uuid}
                    </Row>
                   
                    <Divider></Divider>
                    <Row>
                        Numero da Venda no PDV: <strong>{origem.idLocal}</strong>
                    
                    </Row>
                    <Divider></Divider>
                    <Row>
                        Total Venda: {origem.totalCompra}
                    </Row>
                </>)
            })
        }
    }
    return <Button size='small' type='primary' loading={loadingVendas} onClick={abrirVendaMov}>Ver Detalhes</Button>

}

export {Ajustes}
